import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase.ts';
import sprechheldenHeld from '../assets/sprechheldenHeld.png';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
    } catch (err) {
      // Show errors only for network/rate-limit issues
      // For auth errors (user-not-found, invalid-email), always show success for security
      if (err.code === 'auth/network-request-failed' || err.code === 'auth/too-many-requests') {
        setError(
          err.code === 'auth/too-many-requests'
            ? 'Zu viele Anfragen. Bitte versuche es später erneut.'
            : 'Netzwerkfehler. Bitte überprüfe deine Internetverbindung.'
        );
        setLoading(false);
        return;
      }
    }

    setLoading(false);
    setSubmitted(true);
  };

  return (
    <Container className="min-vh-100 d-flex align-items-center justify-content-center">
      <div className="login-container">
        <Card className="shadow-sm">
          <Card.Body className="px-5 py-4" style={{ borderRadius: 'var(--radius-md)' }}>
            <div className="d-flex align-items-center justify-content-center mb-4">
              <img
                src={sprechheldenHeld}
                alt="Sprechhelden Hero"
                style={{ width: '60px', height: 'auto' }}
                className="login-hero-image me-3"
              />
              <h2 className="mb-0">Sprechhelden</h2>
            </div>

            {!submitted ? (
              <div
                style={{
                  animation: 'fadeIn 0.3s ease-out',
                }}
              >
                <p className="text-center text-muted mb-4">
                  Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.
                </p>

                {error && (
                  <Alert variant="danger" className="mb-3">
                    {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>E-Mail Adresse</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="name@beispiel.de"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                      autoFocus
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3"
                    style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}
                    disabled={loading}
                  >
                    {loading ? 'Wird gesendet...' : 'Link senden'}
                  </Button>
                </Form>

                <p className="text-center text-muted mb-0">
                  <Link
                    to="/login"
                    className="btn btn-link p-0 text-decoration-none"
                  >
                    Zurück zur Anmeldung
                  </Link>
                </p>
              </div>
            ) : (
              <div
                className="text-center"
                style={{
                  animation: 'fadeSlideUp 0.4s ease-out',
                }}
              >
                <div
                  style={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '50%',
                    background: 'var(--clr-green-100)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    animation: 'popIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  }}
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--clr-green-600)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                </div>

                <h5
                  style={{
                    fontWeight: 'var(--font-bold)',
                    color: 'var(--clr-ink-900)',
                    marginBottom: '12px',
                  }}
                >
                  E-Mail gesendet!
                </h5>

                <p
                  className="text-muted mb-4"
                  style={{ fontSize: 'var(--fs-caption)', lineHeight: '1.6' }}
                >
                  Falls ein Konto mit <strong>{email}</strong> existiert,
                  erhältst du in Kürze eine E-Mail mit einem Link zum
                  Zurücksetzen deines Passworts.
                </p>

                <Link
                  to="/login"
                  className="btn btn-primary w-100"
                  style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}
                >
                  Zurück zur Anmeldung
                </Link>
              </div>
            )}
          </Card.Body>
        </Card>

        <style>{`
          @keyframes fadeSlideUp {
            from {
              opacity: 0;
              transform: translateY(12px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes popIn {
            from {
              opacity: 0;
              transform: scale(0.6);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}</style>
      </div>
    </Container>
  );
}

export default ForgotPasswordPage;
